import { useMatchMedia } from '#app/hooks/useMatchMedia.js';
import { useURLParameters } from '#app/hooks/useURLParameters.js';
import { breakpoints } from '#app/theme/breakpoints.js';
import { Grid } from './Grid.js';
import { GridColumn } from './GridColumn.js';
import { styled } from 'styled-components';

const FullScreenContainer = styled.div`
  pointer-events: none;
  position: absolute;
  inset: 0;
  z-index: 9999;
  height: -webkit-fill-available;

  & > div {
    height: 100%;
  }
`;

const StyledGridColumn = styled(GridColumn)`
  background: rgba(242, 201, 76, 0.3);
  height: 100%;
`;

const getColumnWidth = ({ isTabletOrAbove }: { isTabletOrAbove: boolean }) => {
  if (isTabletOrAbove) {
    return 1;
  }

  return 3;
};

export const DebugGrid = () => {
  const [urlSearchParameters] = useURLParameters('*');
  const showGrid = urlSearchParameters.debugGrid;

  const isTabletOrAbove = useMatchMedia(
    `screen and (min-width: ${breakpoints.md})`,
  );

  if (!showGrid) {
    return null;
  }

  return (
    <FullScreenContainer>
      <Grid>
        {Array.from({ length: 12 }).map((_, index) => (
          <StyledGridColumn
            initial={getColumnWidth({ isTabletOrAbove })}
            key={`debug-grid-column-${index}-${
              isTabletOrAbove ? 'desktop' : 'mobile'
            }`}
          />
        ))}
      </Grid>
    </FullScreenContainer>
  );
};
